<div *ngFor="let word of getNlpWords(page); trackBy: trackByIndex;" [ngStyle]="getWordNlpStyles(word)"></div>